import React, { useCallback, useState } from 'react';
import { AppBar, Box, ClickAwayListener, Toolbar } from '@mui/material';
import AppTitle from './AppTitle.tsx';
import BreadcrumbsBar from './breadcrumbs/BreadcrumbsBar.tsx';
import MenuTrigger from './MenuTrigger.tsx';
import NavigationMenu from './NavigationMenu.tsx';
import { managerLayoutStyles } from '../styles.ts';
import type { IManagerHeaderProps } from '../types.ts';

const ManagerHeader: React.FC<IManagerHeaderProps> = ({
  breadcrumbs = [],
  currentPath = '',
  navigation = [],
  onBreadcrumbNavigate = () => undefined,
  onNavigationSelect = () => undefined,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuToggle = useCallback(() => {
    setIsMenuOpen((previousValue) => !previousValue);
  }, []);

  const handleMenuClose = useCallback(() => {
    setIsMenuOpen(false);
  }, []);

  const handleMenuOpen = useCallback(() => {
    setIsMenuOpen(true);
  }, []);

  return (
    <AppBar sx={managerLayoutStyles.topBar}>
      <Box sx={managerLayoutStyles.headerContent}>
        <Toolbar sx={managerLayoutStyles.topBarToolbar}>
          <Box sx={managerLayoutStyles.topBarContent}>
            <ClickAwayListener onClickAway={handleMenuClose}>
              <Box sx={managerLayoutStyles.menuShell}>
                <MenuTrigger isOpen={isMenuOpen} onClick={handleMenuToggle} />

                <NavigationMenu
                  open={isMenuOpen}
                  currentPath={currentPath}
                  navigation={navigation}
                  onClose={handleMenuClose}
                  onOpen={handleMenuOpen}
                  onNavigate={onNavigationSelect}
                />
              </Box>
            </ClickAwayListener>

            <Box sx={managerLayoutStyles.topBarLeft}>
              <AppTitle />
            </Box>
          </Box>
        </Toolbar>

        <Box sx={managerLayoutStyles.breadcrumbsRow}>
          <BreadcrumbsBar breadcrumbs={breadcrumbs} onNavigate={onBreadcrumbNavigate} />
        </Box>
      </Box>
    </AppBar>
  );
};

export default ManagerHeader;
